import React, { useState, useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { getMesaByToken, criarComanda, getComandaByMesa, getComanda } from '../services/api';
import { useCarrinho } from '../services/CarrinhoContext';
import Cardapio from './Cardapio';
import Loading from '../components/Loading';

function Mesa({ brand }) {
  const { token } = useParams();
  const { setMesa, setTipoEntrega, setComanda, setComandaExistente, setUltimaComanda } = useCarrinho();
  const [mesaData, setMesaData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (brand && token) {
      carregarMesa();
    }
  }, [brand, token]);



  const carregarMesa = async () => {
    try {
      setLoading(true);
      // Limpar token removendo caracteres indesejados
      const cleanToken = token.replace(/[^a-zA-Z0-9]/g, '');
      
      const resultado = await getMesaByToken(brand, cleanToken);
      
      if (!resultado) {
        setError('Mesa não encontrada');
        return;
      }

      setMesaData(resultado);
      setMesa(resultado);
      setTipoEntrega('local');
      
      // Se mesa está aberta (disponível), limpar dados de comandas anteriores
      if (resultado.status === 'aberta') {
        localStorage.removeItem('sitri_ultima_comanda');
        setComandaExistente(null);
        setUltimaComanda(null);
        setComanda(null);
      } else {
        // Mesa ocupada - verificar se já existe uma comanda aberta
        const comandaExistente = await getComandaByMesa(brand, cleanToken);
        
        if (comandaExistente && comandaExistente.comanda && 
            comandaExistente.comanda.status !== 'fechada' && 
            comandaExistente.comanda.status !== 'entregue') {
          // Comanda ativa encontrada
          setComandaExistente(comandaExistente.comanda);
          setUltimaComanda(comandaExistente.comanda);
          setComanda({ id: comandaExistente.comanda.id });
          
          localStorage.setItem('sitri_ultima_comanda', JSON.stringify(comandaExistente.comanda));
        } else {
          // Não existe comanda ativa - limpar dados
          localStorage.removeItem('sitri_ultima_comanda');
          setComandaExistente(null);
          setUltimaComanda(null);
          setComanda(null);
        }
      }
      
    } catch (error) {
      setError('Erro ao carregar dados da mesa');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <Loading message="Carregando mesa..." />;
  }

  if (error) {
    return (
      <div className="container mt-5 text-center">
        <div className="alert alert-danger">
          <h4>Erro</h4>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  if (!mesaData) {
    return <Navigate to="/" replace />;
  }

  // Renderizar o cardápio com dados da mesa
  return <Cardapio brand={brand} delivery={false} mesaData={mesaData} />;
}

export default Mesa;